import { Component, ContentChild, HostBinding, Input } from '@angular/core';
import { StepContentDirective } from '../../stepper/step-content.directive';

@Component({
  selector: 'app-laft-step',
  templateUrl: './laft-step.component.html',
  styleUrls: ['./laft-step.component.scss'],
})
export class LaftStepComponent {
  @HostBinding('class.active') @Input() active: boolean;
  @ContentChild(StepContentDirective) stepContent: StepContentDirective;
}
